import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { ActionModal } from "../_components/action-modal.component";
import { Button } from "../_components/button.component";
import { Loader } from "../_components/loader.component";
import Table from "../_components/table.component";
import { UserService } from "../_service/user.service";

export const USER_MANAGEMENT_ROUTE = "/users";

function UserManagementPageComponent({ user, organization, addToast }) {
  const [usersData, setUsersData] = useState([]);
  const [userData, setUserData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        Cell: (data) => {
          return <p className="overflow-auto">{data.row?.values?.name}</p>;
        },
      },
      {
        Header: "Email",
        accessor: "email",
      },
    ],
    []
  );

  useEffect(() => {
    getAllUsers();
  }, [user, organization]);

  const getAllUsers = () => {
    console.log("I AM organization", organization);
    setIsLoading(true);
    if (user?.role == "orgAdmin" && organization !== null) {
      UserService.getOrganizationUsers(user, organization?.organization._id)
        .then((resp) => {
          setUsersData(resp);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          if (error && error.response && error.response.data.message) {
            addToast(error.response.data.message, "", ToastTypes.danger);
          }
        });
    } else if (user?.role === "superAdmin") {
      UserService.getUsers(user)
        .then((resp) => {
          setUsersData(resp);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          if (error && error.response && error.response.data.message) {
            addToast(error.response.data.message, "", ToastTypes.danger);
          }
        });
    }
  };
  return (
    <div className="page-container ml-auto px-9 py-6 org-management-container">
      <div>
        <div className="bg-white card px-11 py-9 relative rounded-lg w-96 w-full">
          <div>
            <div className="flex justify-between">
              <p className="font-bold text-lg text-primary">User Management</p>
            </div>
            {!isLoading ? (
              <div className="mt-5">
                {usersData && usersData.length > 0 ? (
                  <>
                    <Table
                      columns={columns}
                      data={usersData}
                      defaultPageSize={20}
                    />
                  </>
                ) : (
                  <div>
                    <p className="text-primary">User data not found</p>
                  </div>
                )}
              </div>
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const UserManagementPage = withToast(
  connect((state) => ({
    user: state.auth,
    organization: state.orgData,
  }))(UserManagementPageComponent)
);

export default UserManagementPage;
